import cn from 'clsx';
import styles from './styles.module.css';

type Props = {
  className?: string;
  children: string;
};
export const Tag = ({className, children}: Props) => {
  return <span className={cn(styles.Tag, className)}>{children}</span>;
};
